/**
 * LinkedIn InMail character limits, enforced by LinkedIn itself (surfaced via
 * Unipile as `errors/too_many_characters` 400s when exceeded). Shared between
 * the web editors (UX guard while typing) and the API (authoritative check
 * against the fully resolved text that is actually sent).
 */
export const LINKEDIN_INMAIL_SUBJECT_MAX_LENGTH = 200;

export const LINKEDIN_INMAIL_MESSAGE_MAX_LENGTH = 1900;

/**
 * Connection-invite note limits. LinkedIn allows a longer note to Premium and Sales
 * Navigator senders than to free ones, and the send path already picks a different
 * message per tier — so the authoritative check has to know the tier too. Exceeding
 * the limit surfaces from Unipile as an `errors/invalid_parameters` 400 reading
 * "Expected string length less or equal to 300".
 */
export const LINKEDIN_INVITE_NOTE_MAX_LENGTH = 200;

export const LINKEDIN_INVITE_NOTE_PREMIUM_MAX_LENGTH = 300;
